import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FP212 {
  fp212_01: string;
  fp212_02: number;
  fp212_03: number;
  fp212_11: string;  // 測試項目代碼
  fp212_12: string;  // 檢驗規範代碼
  fp212_14: string;  // 公司代號
  fp212_90: number;
  fp212_91: string;
  fp212_92: string | null;
  fp212_93: string;
  // Computed from F11A (read-only, populated by backend on GET)
  f11a_15?: number;  // 輸出畫面格式 (1-5)
  f11a_11?: string;  // 測試項目中文名稱
}

export interface FP211 {
  fp211_01: string;
  fp211_02: number;
  fp211_11: string;         // 色號代碼
  fp211_12: string | null;  // 標準完成日
  fp211_121: string;        // 標準完成時間
  fp211_13: string | null;  // 希望完成日
  fp211_131: string;        // 希望完成時間
  fp211_14: string | null;  // 實際完成日
  fp211_17: string;         // 缸號
  fp211_90: number;
  fp211_91: string;
  fp211_92: string | null;
  fp211_93: string;
  specs?: FP212[];
}

export interface FP210 {
  fp210_01: string;         // 送件單號
  fp210_11: string | null;  // 申請日期
  fp210_12: string;         // 部門代碼
  fp210_13: string;         // 申請人
  fp210_14: string;         // 繳庫/託工單號
  fp210_15: number;         // 繳庫項次
  fp210_17: number;         // 出報告方式
  fp210_171: number;        // 報告種類 (1=中文, 2=英文)
  fp210_18: number;         // 產品類別
  fp210_19: number;         // 明細總筆數
  fp210_20: string;         // 備註代號
  fp210_21: string;         // 備註說明
  fp210_29: string;         // 來源類型
  fp210_30: string;         // 採購/託工單號
  fp210_31: string;         // 業務人員
  fp210_32: string;         // 客戶來樣分析單號
  fp210_33: boolean;        // 不收費
  fp210_34: boolean;        // 印制系統報告
  fp210_35: number;         // 送件分類
  fp210_36: string;         // 客戶代號
  fp210_38: string;         // 產品全名
  fp210_80: string;         // 核准狀態
  fp210_90: number;         // 版本
  fp210_91: string;
  fp210_92: string | null;
  fp210_93: string;
  details?: FP211[];
}

export interface ListResponse {
  data: FP210[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Functions
// ============================================================

const BASE = '/api/p201';

export const p201Api = {
  list: async (page = 1, size = 20, keyword = ''): Promise<ListResponse> => {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get(BASE, { params });
    return res.data;
  },

  get: async (id: string): Promise<FP210> => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data;
  },

  create: async (master: Partial<FP210>, details: Partial<FP211>[]): Promise<FP210> => {
    const res = await apiClient.post(BASE, { master, details });
    return res.data;
  },

  update: async (id: string, master: Partial<FP210>, details: Partial<FP211>[]): Promise<FP210> => {
    const res = await apiClient.put(`${BASE}/${id}`, { master, details });
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },

  getApprovalHistory: async (id: string): Promise<ApprovalHistory[]> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}/approval-history`);
    return res.data.data || [];
  },
};

// ============================================================
// Approval types
// ============================================================

export interface ApprovalHistory {
  id: number;
  order_no: string;
  action: string;
  actor_id: string;
  actor_name: string;
  comment: string;
  old_status: string;
  new_status: string;
  created_at: string;
}

export default p201Api;
